export default __webpack_public_path__ + "static/montserrat-v18-latin-500-ade7985dfab42940651537039e999ad9.woff2";